import { render, staticRenderFns } from "./luxuryyacht.vue?vue&type=template&id=2c2fc3fa&scoped=true&"
import script from "./luxuryyacht.vue?vue&type=script&lang=js&"
export * from "./luxuryyacht.vue?vue&type=script&lang=js&"
import style0 from "./luxuryyacht.vue?vue&type=style&index=0&id=2c2fc3fa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2fc3fa",
  null
  
)

/* custom blocks */
import block0 from "./luxuryyacht.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports